import { render, staticRenderFns } from "./SubjectProfileCard.vue?vue&type=template&id=508a871f&scoped=true&"
import script from "./SubjectProfileCard.vue?vue&type=script&lang=js&"
export * from "./SubjectProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./SubjectProfileCard.vue?vue&type=style&index=0&id=508a871f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a871f",
  null
  
)

export default component.exports